import { PageTitle } from '@/shared/ui/text/page-title';
import { SettingsColumn } from '@/widgets/settings/settings-column';

import { usePracticeDetailsEditing } from '../model/use-practice-details-editing';
import { LocationsSection } from './practice-details-page/locations-section';
import { PracticeInformationSection } from './practice-details-page/practice-information-section';

export function PracticeDetailsPage() {
    // Shared across both sections so opening any one editor — an info field or a location — dims
    // and disables every other row's actions on the page.
    const editing = usePracticeDetailsEditing();

    return (
        <SettingsColumn className="space-y-8">
            <PageTitle>Practice details</PageTitle>

            <PracticeInformationSection editing={editing} />
            <LocationsSection editing={editing} />
        </SettingsColumn>
    );
}
